import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

function Loading(params) {
  const {
    size,
    noWrapper,
    colorClass = "has-text-primary",
  } = params

  if (noWrapper) {
    return <FontAwesomeIcon icon={faSpinner} className="fa-pulse px-2" />
  }

  return (
    <div className="columns">
      <div
        className={`column is-flex is-justify-content-center ${colorClass} is-size-3 ${size} `}
      >
        <FontAwesomeIcon icon={faSpinner} className="fa-pulse p-2" />
      </div>
    </div>
  )
}

export default Loading
